import './index.css';
type Props = {};

const Loader: React.FC<Props> = () => {
  return (
    <div id="spinner-main">
      <div className="loader-outer">
        <div className="loader-spin"></div>
      </div>
    </div>
  );
};

export default Loader;
